module.exports = __webpack_public_path__ + "static/media/giftCardBackground.974745aa.png";